import {defineMessages} from "react-intl";

const messages = defineMessages({
    yes:{
	id:"app.delete-confirmation-modal.yes",
	description:"",
	defaultMessage:"Yes"
    },

    no:{
	id:"app.delete-confirmation-modal.no",
	description:"",
	defaultMessage:"NO"
    },

    confirmationMsg:{
	id:"app.delete-confirmation-modal.confirmationMsg",
	description:"",
	defaultMessage:"Are you sure you want to delete ?"
    },

    undone:{
	id:"app.delete-confirmation-modal.undone",
	description:"",
	defaultMessage:"This action can not be undone"
    }
});


export default messages;
